import React from 'react';
import PropTypes from 'prop-types';

import { IconCountry, Text } from 'components/common/Elements/Elements';

import classes from './LocationBody.module.scss';

const LocationBody = ({ country, size = 16, type = 'n', countryFullName }) => {
  let countryName = '';

  if (type === 'n') {
    countryName = countryFullName;
  }
  if (type === 'c') {
    countryName = country;
  }

  return (
    <div className={classes.wrap}>
      <IconCountry
        country={country}
        style={{
          maxWidth: `${size}px`,
          maxHeight: `${size}px`,
          minWidth: `${size}px`,
          minHeight: `${size}px`
        }}
      />
      <Text size={4} className={classes.text}>
        {countryName}
      </Text>
    </div>
  );
};

LocationBody.propTypes = {
  country: PropTypes.string,
  type: PropTypes.oneOf(['n', 'c']),
  size: PropTypes.number,
  countryFullName: PropTypes.string
};

export default LocationBody;
